import { render } from "./AgentTree.vue?vue&type=template&id=b0a3fdd8"
import script from "./AgentTree.vue?vue&type=script&lang=js"
export * from "./AgentTree.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__